import React from 'react';
import About from './About';

const AboutPage: React.FC = () => {
  return (
    <div className="pt-28 pb-20 min-h-screen cyber-grid-bg">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <About showStrategicPillars={false} />
      </div>
    </div>
  );
};

export default AboutPage;
